__webpack_require__.O(0, ["template.homepage"], function() {
	["vendor.swiper","vendor.waypoints","vendor.ssr-window","vendor.dom7","swiper"].map(__webpack_require__.E);
}, 5);